import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DailyReportComponent } from './daily-report.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { GenerateReportModule } from "./pages/generate-report/generate-report.module";
import { OldReportsModule } from "./pages/old-reports/old-reports.module";
import { DailyReportRoutingModule } from './daily-report-routing.module';

@NgModule({
    declarations: [DailyReportComponent],
    exports: [DailyReportComponent],
    imports: [
        CommonModule,
        MaterialModule,
        GenerateReportModule,
        OldReportsModule,
        DailyReportRoutingModule
    ]
})
export class DailyReportModule {}
